import { render, staticRenderFns } from "./ISANotificationHistoryModal.vue?vue&type=template&id=734bc046&"
import script from "./ISANotificationHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ISANotificationHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ISANotificationHistoryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports